const initialState = {
  status: "invalid",
};

function CurrentUserReducer(state = initialState, action) {
  switch (action.type) {
    case "CURRENT_USER_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "CURRENT_USER_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action.data,
      };
    case "CURRENT_USER_FAILURE":
      return {
        ...state,
        status: "failure",
        err: action.err,
      };
    default:
      return state;
  }
}

export default CurrentUserReducer;
